/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */





// document.querySelectorAll(".product-item__title").forEach((item) => {
//   let tooltipTimeout, tooltip;

//   const createTooltip = (item) => {
//     // Create tooltip element
//     tooltip = document.createElement("span");
//     tooltip.className = "tooltip";
//     tooltip.textContent = item.getAttribute("data-title");
//     document.body.appendChild(tooltip);

//     // Reset styles for positioning
//     tooltip.style.position = "fixed";
//     tooltip.style.visibility = "hidden";
//     tooltip.style.display = "block";

//     // Calculate positions
//     const itemRect = item.getBoundingClientRect();
//     const tooltipRect = tooltip.getBoundingClientRect();
//     const containerWidth = window.innerWidth;
//     const containerHeight = window.innerHeight;

//     let top = itemRect.top - tooltipRect.height - 10; // Default to above
//     let left = itemRect.left + (itemRect.width / 2) - (tooltipRect.width / 2); // Center horizontally
//     // let left = itemRect.left; // left horizontally

//     // Prevent horizontal overflow
//     if (left < 10) left = 10; // Near left edge
//     if (left + tooltipRect.width > containerWidth) left = containerWidth - tooltipRect.width - 10; // Near right edge

//     // Prevent vertical overflow
//     if (top < 10) {
//       top = itemRect.bottom + 10; // Move below
//     } else if (top + tooltipRect.height > containerHeight) {
//       top = itemRect.top - tooltipRect.height - 10; // Move above
//     }

//     // Apply calculated positions
//     tooltip.style.left = `${left}px`;
//     tooltip.style.top = `${top}px`;
//     tooltip.style.visibility = "visible";
//     tooltip.style.opacity = "1";
//   };

//   const removeTooltip = () => {
//     if (tooltip) {
//       tooltip.remove();
//       tooltip = null;
//     }
//   };

//   item.addEventListener("mouseenter", () => {
//     clearTimeout(tooltipTimeout);
//     tooltipTimeout = setTimeout(() => createTooltip(item), 150); // Slight delay for smoother UX
//   });

//   item.addEventListener("mouseleave", () => {
//     clearTimeout(tooltipTimeout);
//     removeTooltip();
//   });
// });

// Select the element
// Wait for 1 second and then change the text

setTimeout(() => {
    const titleElement = document.querySelector('.jdgm-rev-widg__title');
    if (titleElement) {
        titleElement.textContent = "Product-reviews";
    }
console.log('hello');
}, 1000); // 1000 milliseconds = 1 second



// document.querySelectorAll(".product-item__title").forEach((item) => {
//   let tooltipTimeout, tooltip;

//   const createTooltip = (item) => {    
//     tooltip = document.createElement("span");
//     tooltip.className = "tooltip";
//     tooltip.textContent = item.getAttribute("data-title");
//     document.body.appendChild(tooltip);

 
//     tooltip.style.position = "fixed";
//     tooltip.style.visibility = "hidden";
//     tooltip.style.display = "block";

   
//     const itemRect = item.getBoundingClientRect();
//     const tooltipRect = tooltip.getBoundingClientRect();
//     const containerWidth = window.innerWidth;
//     const containerHeight = window.innerHeight;

//     let top = itemRect.top - tooltipRect.height - 10; 
//     let left;

    
//     if (tooltipRect.width <= itemRect.width) {
//       left = itemRect.left; // Align left
//     } else {
//       left = itemRect.left + (itemRect.width / 2) - (tooltipRect.width / 2); 
//     }


//     if (left < 10) left = 10; 
//     if (left + tooltipRect.width > containerWidth) left = containerWidth - tooltipRect.width - 10; 

 
//     if (top < 10) {
//       top = itemRect.bottom + 10; 
//     } else if (top + tooltipRect.height > containerHeight) {
//       top = itemRect.top - tooltipRect.height - 10; 
//     }

//     tooltip.style.left = `${left}px`;
//     tooltip.style.top = `${top}px`;
//     tooltip.style.visibility = "visible";
//     tooltip.style.opacity = "1";
//   };

//   const removeTooltip = () => {
//     if (tooltip) {
//       tooltip.remove();
//       tooltip = null;
//     }
//   };

//   item.addEventListener("mouseenter", () => {
//     clearTimeout(tooltipTimeout);
//     tooltipTimeout = setTimeout(() => createTooltip(item), 150); 
//   });

//   item.addEventListener("mouseleave", () => {
//     clearTimeout(tooltipTimeout);
//     removeTooltip();
//   });
// });

// below code only includes mobile scroll hide functionality

document.querySelectorAll(".product-item__title").forEach((item) => {
  let tooltipTimeout, tooltip;

  const createTooltip = (item) => {
    removeTooltip();

    tooltip = document.createElement("span");
    tooltip.className = "tooltip";
    tooltip.textContent = item.getAttribute("data-title");
    document.body.appendChild(tooltip);

    tooltip.style.position = "fixed";
    tooltip.style.visibility = "hidden";
    tooltip.style.display = "block"; 
    const itemRect = item.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const containerWidth = window.innerWidth;
    const containerHeight = window.innerHeight;

    let top = itemRect.top - tooltipRect.height - 10;
    let left = itemRect.left + (itemRect.width / 2) - (tooltipRect.width / 2);

    if (left < 10) left = 10;
    if (left + tooltipRect.width > containerWidth) left = containerWidth - tooltipRect.width - 10;

    if (top < 10) {
      top = itemRect.bottom + 10;
    } else if (top + tooltipRect.height > containerHeight) {
      top = itemRect.top - tooltipRect.height - 10;
    }

    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;
    tooltip.style.visibility = "visible";
    tooltip.style.opacity = "1";

    document.addEventListener("touchstart", handleOutsideClick, { passive: true });
    window.addEventListener("scroll", removeTooltip, { passive: true });
  };

  const removeTooltip = () => {
    if (tooltip) {
      tooltip.remove();
      tooltip = null;
    }
    document.removeEventListener("touchstart", handleOutsideClick);
    window.removeEventListener("scroll", removeTooltip);
  };

  const handleOutsideClick = (event) => {
    if (tooltip && !event.target.closest(".product-item__title")) {
      removeTooltip();
    }
  };

  item.addEventListener("mouseenter", () => {
    clearTimeout(tooltipTimeout);
    tooltipTimeout = setTimeout(() => createTooltip(item), 150);
  });

  item.addEventListener("mouseleave", () => {
    clearTimeout(tooltipTimeout);
    removeTooltip();
  });
});

